export default __webpack_public_path__ + "static/media/drop-off.4da5c54f.svg";